import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import GroupAddIcon from '@mui/icons-material/GroupAdd'
import { LoadingButton } from '@mui/lab'

import { Network } from '@/core/models/network.model'
import { useSendNetworkJoinRequestMutation } from '@/core/services/network'

import { getApiErrorMessage } from '@/utils/errors'

type JoinNetworkButtonProps = {
  network: Network
}

export default function JoinNetworkButton({ network }: JoinNetworkButtonProps) {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [joinNetwork, { isLoading }] = useSendNetworkJoinRequestMutation()

  return (
    <LoadingButton
      loading={isLoading}
      startIcon={<GroupAddIcon />}
      onClick={async () => {
        try {
          await joinNetwork(network._id).unwrap()
        } catch (error) {
          enqueueSnackbar(getApiErrorMessage(error, t('notification.network.join.error')), { variant: 'error' })
        }
      }}
      variant="contained"
    >
      {t('common:button.join.label')}
    </LoadingButton>
  )
}
